module.exports = __webpack_public_path__ + "img/970x250_layout_1.cde7cf9e.svg";